export default "__VITE_ASSET__D0tySWZI__"